import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../../_metronic/partials'
import {AdminPortalLayout} from './AdminPortalLayout'
import PostCodeMatrix from './pages/LookUpTables/PostCodeMatrix/PostCodeMatrix'
import Product from './pages/Products/Products'
import ProductDetailsPage from './pages/Products/ProductDetailsPage'
import {useHistory} from 'react-router-dom'
import {AdminContextProvider} from '../../context/AdminContext'
import { AdminOrderSummaryContextProvider } from '../../context/AdminOrderSummaryContext'
import { UserModel } from '../../modules/auth/models/UserModel'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { USER_TYPES } from '../../../utils'
import Dashboard from '../customer/pages/Dashboard/Dashboard'
import {QuickOrderContent} from '../quick-order/components/QuickOrderContent'
import {CheckoutContent} from '../checkout/components/CheckoutContent'
import OrderSummaryContent from '../order-summary/components/OrderSummaryContent'
import ConfirmOrderContent from '../confirm-order/ConfirmOrderContent'

export function AdminRoutes() {
  let user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  const isAdminUser = user?.userRoles?.includes(USER_TYPES.ADMIN)
  const isSalesRep = user?.userRoles?.includes(USER_TYPES.USER)
  const isCustomer = user?.userRoles?.includes(USER_TYPES.CUSTOMER)
  const PriceBook = lazy<React.FC>(() => import('./pages/PriceBooks/PriceBooks'))
  const LookUpTable = lazy<React.FC>(() => import('./pages/LookUpTables/LookUpTables'))
  const Regions = lazy<React.FC>(() => import('./pages/LookUpTables/Regions/Regions'))
  const Orders = lazy(() => import('./pages/Orders/Orders'))
  const Colours = lazy<React.FC>(() => import('./pages/Colours/Colours'))
  const OrderDetails = lazy(() => import('./pages/Orders/OrderDetailsPage/OrderDetailsPage'))
  const TopographicalClassificationMatrix = lazy<React.FC>(
    () =>
      import(
        './pages/LookUpTables/TopographicalClassificationMatrix/TopographicalClassificationMatrix'
      )
  )
  const WindClassification = lazy<React.FC>(
    () => import('./pages/LookUpTables/WindClassification/WindClassification')
  )
  const SpanMatrix = lazy<React.FC>(() => import('./pages/LookUpTables/SpanMatrix/SpanMatrix'))
  const LoadCapacityMatrix = lazy<React.FC>(
    () => import('./pages/LookUpTables/LoadCapacityMatrix/LoadCapacityMatrix')
  )
  const BeamUpliftLoadsMatrix = lazy<React.FC>(
    () => import('./pages/LookUpTables/BeamUpliftLoadsMatrix/BeamUpliftLoadsMatrix')
  )

  const history = useHistory()


  return (
    <AdminPortalLayout>
      <Suspense fallback={<FallbackView />}>
        <AdminContextProvider>
          <Switch>
            {isSalesRep && (
              <>
                <Route exact path='/admin/orders' render={() => <Orders />} />
                <Route exact path='/admin/orders/:id' render={() => 
                  <AdminOrderSummaryContextProvider>
                    <OrderDetails />
                  </AdminOrderSummaryContextProvider>
                } />
                <Route exact path='/dashboard'>
                  <Redirect to='/admin/orders' />
                </Route>
              </>
            )}
            
            {isAdminUser && (
              <>
                <Route exact path='/admin/orders' render={() => <Orders />} />
                <Route exact path='/admin/orders/:id' render={() => 
                  <AdminOrderSummaryContextProvider>
                    <OrderDetails />
                  </AdminOrderSummaryContextProvider>
                } />
                <Route exact path='/dashboard'>
                  <Redirect to='/admin/orders' />
                </Route>
                
                <Route exact path='/admin/lookup-tables' render={() => <LookUpTable />} />
                <Route exact path='/admin/products' render={() => <Product />} />
                <Route
                  exact
                  path='/admin/product-details/:productType/:productId'
                  render={(props) => (
                    <ProductDetailsPage
                      productType={props.match.params.productType}
                      productId={props.match.params.productId}
                      onClose={() => history.push('/admin/products')}
                    />
                  )}
                />
                <Route
                  exact
                  path='/admin/lookup-tables/post-code-matrix'
                  render={() => <PostCodeMatrix />}
                />
                <Route exact path='/admin/lookup-tables/regions' render={() => <Regions />} />
                <Route
                  exact
                  path='/admin/lookup-tables/topographical-classification-matrix'
                  render={() => <TopographicalClassificationMatrix />}
                />
                <Route
                  exact
                  path='/admin/lookup-tables/wind-classification'
                  render={() => <WindClassification />}
                />
                <Route exact path='/admin/lookup-tables/span-matrix' render={() => <SpanMatrix />} />
                <Route
                  exact
                  path='/admin/lookup-tables/load-capacity-matrix'
                  render={() => <LoadCapacityMatrix />}
                />
                <Route
                  exact
                  path='/admin/lookup-tables/beam-uplift-loads-matrix'
                  render={() => <BeamUpliftLoadsMatrix />}
                />
                <Route
                  exact
                  path='/admin/colours'
                  render={() => <Colours />}
                />
              </>
            )}

            {isCustomer && (
              <>
                <Route exact path='/customer/dashboard' component={Dashboard} />
                <Route exact path='/customer/orders' render={() => <Orders isCustomerPortal email={user?.email} />} />
                <Route exact path='/customer/quick-order' render={() => <QuickOrderContent isCustomerPortal email={user?.email} />} />
                <Route exact path='/customer/quick-order/checkout' render={() => <CheckoutContent isCustomerPortal email={user?.email} />} />
                <Route exact path='/customer/quick-order/order-summary' render={() => <OrderSummaryContent isCustomerPortal email={user?.email} />} />
                <Route exact path='/customer/quick-order/confirm-order' render={() => <ConfirmOrderContent isCustomerPortal />} />

                <Route exact path='/customer/orders/:id' render={() => 
                  <AdminOrderSummaryContextProvider>
                    <OrderDetails isCustomerPortal email={user?.email} />
                  </AdminOrderSummaryContextProvider>
                } />

                <Route exact path='/dashboard'>
                  <Redirect to='/customer/dashboard' />
                </Route>
              </>
            )}
          </Switch>
        </AdminContextProvider>
      </Suspense>
    </AdminPortalLayout>
  )
}
